/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoDataPublishResultCto } from '../../models/demo-data-publish-result-cto';

export interface RestoreDemoAccountDataVersionAsync$Plain$Params {
  demoDataType: ClassificationType;
  documentId: string;
}

export function restoreDemoAccountDataVersionAsync$Plain(http: HttpClient, rootUrl: string, params: RestoreDemoAccountDataVersionAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
  const rb = new RequestBuilder(rootUrl, restoreDemoAccountDataVersionAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoDataPublishResultCto>;
    })
  );
}

restoreDemoAccountDataVersionAsync$Plain.PATH = '/demo-account-data/{demoDataType}/history/{documentId}/restore';
